(function () {
    myonce('controller_ready', function () {
        trigger(document, "ControllerReady");
    });
}());
